import React, { memo, useMemo } from 'react';
import { DemeterDataFrequency, DemeterDataSource, DemeterSymbolModel } from '../../../../Generated/Raven-Demeter';
import BarChartRaw from '../../../Components/Charts/Bar/BarChartRaw';
import { IChartDataSeries } from '../../../Components/Charts/ChartDefinitions';
import ChartWrapper from '../../../Components/Charts/ChartWrapper/ChartWrapper';
import useLanguage from '../../../Services/Language/useLanguageHook';
import { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import { MonthlyRiskCompositeModel, RiskRequest } from '../RiskDefinitions';

export interface INetPositionChart {
    symbol: DemeterSymbolModel;
    risksRequest: RiskRequest;
    calculatedRisks: MonthlyRiskCompositeModel[];
    track: TrackingEvent;
}

const NetPositionChart: React.FC<INetPositionChart> = (props: INetPositionChart) => {
    const [translations] = useLanguage();

    const barSeries = useMemo<IChartDataSeries[]>(
        () => [
            {
                label: translations.risk.text.netPhysicalPosition,
                data: props.calculatedRisks.map((x) => ({
                    value: x.physicalPosition ?? 0,
                    asOfDate: new Date(x.dataYear, x.dataMonth, 1),
                    isActualValue: true,
                })),
            },
            {
                label: translations.risk.text.netFuturesSwapPosition,
                data: props.calculatedRisks.map((x) => ({
                    value: x.futuresPosition ?? 0,
                    asOfDate: new Date(x.dataYear, x.dataMonth, 1),
                    isActualValue: true,
                })),
            },
        ],
        [props.calculatedRisks],
    );

    return (
        <ChartWrapper
            name="NetPositionChart"
            title={translations.risk.headers.netPosition}
            dataSourceTag={[translations.exchange[props.symbol.exchange], translations.dataSource[DemeterDataSource.StoneXCalculations]]}
            isLoading={props.calculatedRisks.length === 0}
            track={props.track}
        >
            <BarChartRaw barSeries={barSeries} unitOfMeasure={props.risksRequest.unitOfMeasure} format="value" dataFrequency={DemeterDataFrequency.Monthly} />
        </ChartWrapper>
    );
};

export default memo(NetPositionChart);
